import { render, staticRenderFns } from "./PropertyManagement.vue?vue&type=template&id=1d818c3a&scoped=true&"
import script from "./PropertyManagement.vue?vue&type=script&lang=js&"
export * from "./PropertyManagement.vue?vue&type=script&lang=js&"
import style0 from "./PropertyManagement.vue?vue&type=style&index=0&id=1d818c3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d818c3a",
  null
  
)

export default component.exports